<template>
  <v-card style="padding: 4px 16px">
    <v-data-table
      :rows-per-page-text="$t('dataTables.rowsPerPage')"
      :rows-per-page-items="rowsPerPage"
      :no-data-text="$t('dataTables.noData')"
      :headers="providerDishesHeaders"
      :items="dayProviderDishes"
      :loading="loading > 0"
      :hide-actions="printing"
      :hide-headers="printing"
    >
      <template slot="items" slot-scope="props">
        <td style="min-width: 190px;">{{ props.item.title }}</td>
        <td class="text-xs-right">{{ props.item.requestsCount }}</td>
      </template>
      <template slot="footer">
        <td colspan="100%" class="pr-4">
          <div>
            <strong><span v-t="'dataTables.soupsCount'" /> {{ soupsCount }}</strong>
          </div>
          <div>
            <strong><span v-t="'dataTables.mainsCount'" /> {{ mainDishesCount }}</strong>
          </div>
        </td>
      </template>
      <template slot="pageText" slot-scope="props">
        {{ $t('dataTables.pagingRow', { start: props.pageStart, stop: props.pageStop, length: props.itemsLength }) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import gql from 'graphql-tag';
import { mapGetters } from 'vuex';
import NotificationService from '@/services/NotificationService';
import ErrorHandler from '@/services/ErrorHandler';

export default {
  name: 'DayProviderDishesTable',
  props: {
    dayProviderId: {
      type: Number,
      default: undefined,
    },
    printing: Boolean,
  },
  data() {
    return {
      loading: 0,
      dayProviderDishes: [],
    };
  },
  computed: {
    ...mapGetters('userInfoStore', ['userData']),
    providerDishesHeaders() {
      return [
        {
          text: this.$t('ordersCountContainer.dishName'), align: 'left', sortable: true, value: 'title',
        },
        {
          text: this.$t('ordersCountContainer.count'), align: 'right', sortable: true, value: 'requestsCount',
        },
      ];
    },
    rowsPerPage() {
      return [10, 20, 30];
    },
    soupsCount() {
      return this.dayProviderDishes.filter(d => d.isSoup).reduce((acc, d) => acc + d.requestsCount, 0);
    },
    mainDishesCount() {
      return this.dayProviderDishes.filter(d => !d.isSoup).reduce((acc, d) => acc + d.requestsCount, 0);
    },
  },
  apollo: {
    $loadingKey: 'loading',
    dayProviderDishes: {
      fetchPolicy: 'network-only',
      query: gql`query DayProviderDishesQuery($dayProviderId: Int!, $languageId: Int) {
        dayProviderDishes(dayProviderId: $dayProviderId) {
          title(languageId: $languageId)
          isSoup
          requestsCount
        }
      }`,
      variables() {
        return {
          dayProviderId: this.dayProviderId,
          languageId: this.userData.languageId,
        };
      },
      skip() {
        return !this.dayProviderId;
      },
      error(error) {
        ErrorHandler.handleApolloError(error);
      },
      result(r) {
        if (!r.loading) {
          NotificationService.clearNetworkNotification();
        }
      },
    },
  },
};
</script>
